export const actions = {
	LOADING: 'LOADING',
	SET_ALL_TASKS: 'SET_ALL_TASKS',
	SET_TASK: 'SET_TASK',
	TASK_ERROR: 'TASK_ERROR',
	UPDATE_TASK: 'UPDATE_TASK',
	LOGIN_ERROR: 'LOGIN_ERROR',
	SET_TOKEN: 'SET_TOKEN',
	CHECK_TOKEN: 'CHECK_TOKEN',
};
